import { Box } from "@mui/material";
import StyledDataGrid from "components/StyledDataGrid";

const EntitiesByEnvironmentTableWidget = ({ summary, isLoading }) => {
  const entitiesByEnvRows = summary?.entities_by_env
    ? Object.entries(summary.entities_by_env).map(([envId, count], idx) => ({
        id: idx,
        env_id: envId,
        count: count,
      }))
    : [];

  const entityEnvColumns = [
    { field: "env_id", headerName: "Environment", flex: 1 },
    { field: "count", headerName: "Count", flex: 0.5 },
  ];

  return (
    <Box sx={{ height: "100%" }}>
      <StyledDataGrid
        rows={entitiesByEnvRows}
        columns={entityEnvColumns}
        loading={isLoading}
        disableRowSelectionOnClick
        pageSizeOptionsOverride={[10, 25, 50]}
      />
    </Box>
  );
};

export default EntitiesByEnvironmentTableWidget;
